/**
 * Application-wide constants for SpecialTask module
 */

export const MAPBOX_TOKEN =
  import.meta.env.VITE_MAPBOX_TOKEN ||
  'pk.eyJ1IjoiZWxkYSIsImEiOiJjbG9jYTgxNWswMXR3MmtxZmhqN2hsMGVyIn0.-x8XXyQJJFTmbujKJMK-Kg'

export const DEFAULT_MAP_CENTER = [6.55944, 44.92226]
export const DEFAULT_MAP_ZOOM = 12.25
export const DEFAULT_MAP_PITCH = 0
export const DEFAULT_MAP_BEARING = -142.69

export const PRIORITIES = ['Bas', 'Moyen', 'Haut', 'Urgent']

export const PRIORITY_COLORS = {
  bas: '#10B981',
  moyen: '#F59E0B',
  haut: '#EF4444',
  urgent: '#7F1D1D',
}

// miroir de BASE_SERVICES du back (utils/baseServices.js)
export const DEFAULT_SERVICES = [
  { value: 'neige', label: 'Neige' },
  { value: 'damage', label: 'Damage' },
  { value: 'maintenanceRM', label: 'Maintenance RM' },
  { value: 'piste', label: 'Piste' },
  { value: 'exploitation', label: 'Exploitation' },
  { value: 'RM', label: 'RM' },
  { value: 'autre', label: 'Autre' },
]

export const LOCATION_TYPES = {
  area: 'Zone',
  building: 'Bâtiment',
  lift: 'Remontée',
  other: 'Autre',
}

export const TASK_STATUSES = {
  pending: 'Brouillon',
  inProgress: 'En cours',
  completed: 'Terminé',
  cancelled: 'Annulé',
}

export const PRIORITY_MAPPING = {
  Bas: 'bas',
  Moyen: 'moyen',
  Haut: 'haut',
  Urgent: 'urgent',
}
